export default __webpack_public_path__ + "static/media/love.9b92dc1e.mp3";